import { createWebHistory, createRouter } from 'vue-router';

/* Layouts */
import app from './layouts/app.vue';

/* Pages */
import index from './pages/index.vue';

/* Routes */
const routes = [
    {
        path: '/',
        component: app,
        children: [
            { path: '', name: 'index', component: index }
        ]
    }
];

const router = createRouter({
    scrollBehavior(to, from, savedPosition) {
        if(to.hash) {
            return {
              el: to.hash,
              top: 100,
              behavior: 'smooth'
            }
        }else{
            return { top: 0 }
        }
    },
    history: createWebHistory(),
    routes,
});

export default router;
